import { RecentSearch } from '@/core/graphql/generated/types';
import { PendingView } from '@/core/store/recentHistory/recentHistory.types';

import { ValidProfileVisit } from '../_types/QuickSearch.types';

export const RESULTS_TO_SHOW = 4;

const processPending = <T>(
	views: T[],
	pendingItem: T,
	previousItem: T | undefined,
	isSameItem: (a: T, b: T) => boolean,
	itemDate: (item: T) => string | Date
) => {
	const index = views.findIndex(v => isSameItem(v, pendingItem));

	if (index > -1) {
		const listDate = new Date(itemDate(views[index]));
		const pendingDate = new Date(itemDate(pendingItem));

		if (listDate <= pendingDate) {
			if (previousItem) {
				views[index] = previousItem;
			} else {
				views.splice(index, 1);
			}
		}
	}

	return views
		.sort(
			(a, b) =>
				new Date(itemDate(b)).getTime() - new Date(itemDate(a)).getTime()
		)
		.slice(0, RESULTS_TO_SHOW);
};

export const handlePendingView = (
	orignal: ValidProfileVisit[] | RecentSearch[],
	pendingView: PendingView
) => {
	if (!pendingView || orignal.length === 0)
		return orignal.slice(0, RESULTS_TO_SHOW);

	const views = [...orignal];
	const { pending, previous } = pendingView;

	if (
		views[0].__typename === 'ProfileVisit' &&
		pending.__typename === 'ProfileVisit'
	) {
		return processPending(
			views as ValidProfileVisit[],
			pending,
			previous as ValidProfileVisit | undefined,
			(a, b) => a.profile.veevaid_V === b.profile.veevaid_V,
			item => item.lastVisit
		);
	}

	if (
		views[0].__typename === 'RecentSearch' &&
		pending.__typename === 'RecentSearch'
	) {
		return processPending(
			views as RecentSearch[],
			pending,
			previous as RecentSearch | undefined,
			(a, b) => a.searchKey === b.searchKey && a.entityType === b.entityType,
			item => item.lastSearch
		);
	}

	return orignal.slice(0, RESULTS_TO_SHOW);
};
